import { TrackingFeature } from '../types/feature';

export const USFeature: TrackingFeature = {
  enabledFacebookCapiV2: false,
  enabledTrackProductPageViewMoreThan3: true,
};
